// import axios from "axios";
// import { GET_USER_LIST, POST_LOGIN, POST_SIGNUP } from "../../utils/api";
// import { SIGNUP_FAILURE, SIGNUP_SUCCESS, USER_DETAILS_FAILURE, USER_DETAILS_SUCCESS, USERLIST_FAILURE, USERLIST_SUCCESS } from "./auth.actionTypes";

// export const signup = (payLoad) => async (dispatch) => {
//   try {
//     const resp = await axios.post(POST_SIGNUP, payLoad, {
//       headers: { "Content-Type": "application/json" },
//     });

//     if (resp.status === 200) {
//       localStorage.setItem("access_token", resp.data.access_token);
//       dispatch({
//         type: SIGNUP_SUCCESS,
//         payload: { data: resp.data },
//       });
//       return { success: true };
//     } else {
//       dispatch({
//         type: SIGNUP_FAILURE,
//         payload: { message: resp?.data },
//       });
//       return { success: false, message: resp?.data };
//     }
//   } catch (error) {
//     const errorMsg = error?.response?.data?.detail || "Something went wrong";
//     dispatch({
//       type: SIGNUP_FAILURE,
//       payload: { message: errorMsg },
//     });
//     return { success: false, message: errorMsg };
//   }
// };


// export const getUserList = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_USER_LIST, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: USER_DETAILS_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: USER_DETAILS_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: USER_DETAILS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };



import { apiRequest } from "../../api/apiRequest";
import { GET_USER_LIST, POST_LOGIN, POST_SIGNUP } from "../../utils/api";
import { SIGNUP_FAILURE, SIGNUP_SUCCESS, USER_DETAILS_FAILURE, USER_DETAILS_SUCCESS, USERLIST_FAILURE, USERLIST_SUCCESS } from "./auth.actionTypes";

export const signup = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_SIGNUP, payLoad);

  if (result.success) {
    localStorage.setItem("access_token", result.data.access_token);
    dispatch({
      type: SIGNUP_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  }

  dispatch({
    type: SIGNUP_FAILURE,
    payload: { message: result.message },
  });
  return { success: false, message: result.message };
};

export const getUserList = () => async (dispatch) => {
  const result = await apiRequest("get", GET_USER_LIST);

  if (result.success) {
    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: USER_DETAILS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};